import { useValidateZipCode as useValidate } from '@customink/project-service-react-components';
import { atom, useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { rollbar } from '@/config/rollbar.config';
import { isNotFoundError } from '@/utils/requests';

export const hasValidZipCodeAtom = atom(false);

export const useValidateZipCode = () => {
  const [trigger, response] = useValidate();
  const setHasValidZipCode = useSetAtom(hasValidZipCodeAtom);

  useEffect(() => {
    const isInvalid = isNotFoundError(response?.error);

    if (!response.isError && !response.isUninitialized && !response.isLoading) {
      setHasValidZipCode(!isInvalid);
    }

    if (!response.isError || !isInvalid) return;

    rollbar.critical(
      'Unable to validate zip code due to unhandled network failure',
      response,
    );
  }, [response, setHasValidZipCode]);

  return [trigger, response] as const;
};
